module.exports = {
	"firstName": "nanda",
	"name": "nanda schwarz",
	"shortname": "nanda-schwarz",
	"website_handle": "Srevolrof.blogspot.de",
	"website_url": "https://srevolrof.blogspot.de",
	"instagram_handle": "nanda_schwarz",
	"instagram_url": "https://www.instagram.com/nanda_schwarz/?hl=en",
	"description": "With her quirky and colorful style, Nanda shares her unique vision of style from Cologne, Germany, with the rest of the world. Artsy, upbeat and edgy, Nanda takes inspiration from everything and everyone around her.",
	"interview": [
		{
			"title": "1. What was the most difficult part of the creative process to make the collection?",
			"description": "I think the most difficult part for me was to figure out if I wanted to create single pieces or pieces that look like they are one collection. I had so many ideas, so it was really hard to decide because I love a lot of different styles."
		},
		{
			"title": "2. If you had to choose a song to describe you, what song would it be?",
			"description": "This is a difficult one. I’m a huge fan of David Bowie and think all his songs are just so amazing. I think pretty much every one of his songs describes me in one way or another."
		},
		{
			"title": "3. Vintage or new?",
			"description": "Definitely vintage, because with vintage shopping becomes a search. Once you’ve found something you really like, you have this feeling that that item is that one unique and special piece, waiting for you, meant to be yours!"
		}
	],
	"quote": "Working with Noisy may showed me how much goes into creating a collection, it was so cool experiencing this all",
	"media": [
		"/media/img/influencers/nanda/nanda-schwarz_slider-1.jpg",
		"/media/img/influencers/nanda/nanda-schwarz_slider-2.jpg",
		"/media/img/influencers/nanda/nanda-schwarz_slider-3.jpg",
		"/media/img/influencers/nanda/nanda-schwarz_slider-4.jpg"
	],
	"socialItems": [
		{
			"url": "https://www.instagram.com/p/BI-DZAKhszj/",
			"img": "https://scontent-ams3-1.cdninstagram.com/t51.2885-15/e35/13734300_2066761796882930_623117063_n.jpg?ig_cache_key=MTMxNDUwMzA1MzU0MTgyMTY2Nw%3D%3D.2",
			"likes": 5848
		},
		{
			"url": "https://www.instagram.com/p/BI9tUqZhcUl/",
			"img": "https://scontent-ams3-1.cdninstagram.com/t51.2885-15/e35/13744160_1163715367019077_1278559772_n.jpg?ig_cache_key=MTMxNDQwNTk5ODI2OTk0MTAyOQ%3D%3D.2",
			"likes": 7223
		},
		{
			"url": "https://www.instagram.com/p/BJdVjSBBk5j/",
			"img": "https://scontent-ams3-1.cdninstagram.com/t51.2885-15/e35/14073252_651002261735914_1565066309_n.jpg?ig_cache_key=MTMyMzMwODY0OTAxOTc1NjEzMQ%3D%3D.2",
			"likes": 2813
		},
		{
			"url": "https://www.instagram.com/p/BMGgV1agzRF/",
			"img": "https://scontent-ams3-1.cdninstagram.com/t51.2885-15/e35/14624834_1094516797312658_2804623028791541760_n.jpg?ig_cache_key=MTM3MDkyNTM3NDUzMTM4NDM4OQ%3D%3D.2",
			"likes": 7452
		},
		{
			"url": "https://www.instagram.com/p/BMRUmtjg6RF/",
			"img": "https://scontent-ams3-1.cdninstagram.com/t51.2885-15/e35/14549938_560793974105918_7691987248304095232_n.jpg?ig_cache_key=MTM3Mzk2OTk4MjUwOTI2MTg5Mw%3D%3D.2",
			"likes": 3696
		},
		{
			"url": "https://www.instagram.com/p/BNj8loEgBqN/",
			"img": "https://scontent-ams3-1.cdninstagram.com/t51.2885-15/e35/15306559_852614391508310_4492576422006620160_n.jpg?ig_cache_key=MTM5NzIyNjc3Nzg1MTQ2ODQyOQ%3D%3D.2",
			"likes": 4011
		}
	]
};


//////////////////
// WEBPACK FOOTER
// ./data/influencers/nanda-schwarz.json
// module id = 77
// module chunks = 0